// Commission and money helpers for SigortaPro
export const money = (n) =>
  new Intl.NumberFormat("tr-TR", { style: "currency", currency: "TRY", maximumFractionDigits: 0 }).format(n || 0);

export const money2 = (n) =>
  new Intl.NumberFormat("tr-TR", { style: "currency", currency: "TRY", maximumFractionDigits: 2 }).format(n || 0);

export const daysLeft = (date) => Math.ceil((new Date(date) - new Date()) / 86400000);

// Calculates commission chain based on user's formula:
// brüt → net (÷ netDivisor, veya manuel netOverride) → acente komisyonu (× branşOranı%) → kişisel pay (× personalShare%)
// Also subtracts cancellation refund if policy is cancelled with a manual refund amount.
export const calcCommission = (premium, branchRate, netDivisor = 1.12, personalShare = 60, netOverride = null, cancellationRefund = null) => {
  const brut = Number(premium) || 0;
  const rate = Number(branchRate) || 0;
  const div = Number(netDivisor) || 1.12;
  const share = Number(personalShare) || 60;
  const override = Number(netOverride);
  const net = override > 0 ? override : (div ? brut / div : brut);
  const agency = net * (rate / 100);
  const personalRaw = agency * (share / 100);
  const refund = Number(cancellationRefund);
  const refundAmount = Number.isFinite(refund) && refund > 0 ? refund : 0;
  const personal = Math.max(0, personalRaw - refundAmount);
  return { brut, net, agency, personal, personalRaw, refund: refundAmount, rate, share };
};

export const branchRateOf = (branchName, branches) => {
  const b = branches?.find?.((x) => x.name === branchName);
  return b?.commissionRate ?? 15;
};

// Effective commission rate for a policy: use policy's own rate if user overrode it, otherwise fall back to branch rate.
export const effectiveRate = (policy, branches) => {
  const r = Number(policy?.commissionRate);
  if (r > 0) return r;
  return branchRateOf(policy?.branch, branches);
};

// Customer-based agent commission: if the policy's customer has a commissionRate (percentage),
// returns kişisel × customer.commissionRate / 100 (what we pay out to the referring agent/gallery).
// Returns 0 when there's no customer or no commission rate configured.
export const customerCommissionRate = (policy, customers) => {
  const name = (policy?.customer || "").trim().toLocaleLowerCase("tr");
  if (!name || !Array.isArray(customers)) return 0;
  const c = customers.find((x) => (x?.name || "").trim().toLocaleLowerCase("tr") === name);
  const r = Number(c?.commissionRate);
  return Number.isFinite(r) && r > 0 ? r : 0;
};

export const calcAgentCommission = (policy, customers, branches, settings) => {
  const rate = customerCommissionRate(policy, customers);
  if (rate <= 0) return { rate: 0, agent: 0, netEarning: 0 };
  const c = calcCommission(policy.premium, effectiveRate(policy, branches), settings?.netDivisor, settings?.personalShare, policy.netPremium, policy.status === "iptal" ? policy.cancellationRefund : null);
  const agent = c.personal * (rate / 100);
  return { rate, agent, netEarning: c.personal - agent };
};

export const QUOTE_STATUSES = ["Taslak", "Gönderildi", "Pazarlık", "Kabul", "Reddedildi", "Dönüştürüldü"];

export const QUOTE_STATUS_COLORS = {
  "Taslak": "slate",
  "Gönderildi": "blue",
  "Pazarlık": "amber",
  "Kabul": "green",
  "Reddedildi": "red",
  "Dönüştürüldü": "teal",
};
